import React from 'react';
import { useTranslation } from 'next-i18next';

import ContactSalesForm from 'src/components/ContactSalesForm';

import Card from '../Card';

import styles from './styles.module.scss';
import { fireGA } from 'src/utils/gaUtils';

interface Props {
    className?: string;
    gaLabel?: string;
}

const ContactSalesCard = (props: Props) => {
    const { t } = useTranslation();

    return (
        <Card className={`${styles.contactSalesCard} ${props.className}`}>
            <ContactSalesForm
                className={styles.contactSalesForm}
                titleClassName={styles.title}
                submitButtonClassName={styles.button}
                title={t('contact_sales_card_title')}
                description={t('contact_sales_card_description')}
                onFireGa={() => fireGA('marketingQ421', 'clickContactUs', props.gaLabel)}
            />
        </Card>
    );
};

ContactSalesCard.defaultProps = {
    className: '',
    gaLabel: '',
};

export default ContactSalesCard;
